import clsx from 'clsx';
import React from 'react';
import { IconSpinnerNormal } from '@byted-tiktok/tux-icons';

var TUXSpinner = function TUXSpinner(_ref) {
  var size = _ref.size,
      className = _ref.className;
  return /*#__PURE__*/React.createElement(IconSpinnerNormal, {
    style: {
      fontSize: size
    },
    className: clsx("TUXSpinner flex-shrink-0", className)
  });
};

export { TUXSpinner };
//# sourceMappingURL=TUXSpinner.js.map
